import {linspace} from '../utils/utils.js';

export default class Particles {
  constructor(parentGlobe) {
    this.config = parentGlobe.config;
    this.npart = parentGlobe.config.flow.npart;
    this.particles = new Array(this.npart);
    for (var i = 0; i<this.config.flow.npart; i++) {
      this.particles[i] = {};
      this.particles[i].position = new Array(2);
      this.particles[i].newposition = new Array(2);
    }

    this.initAll();

    this.parentGlobe = parentGlobe;
    this.sizeθ = this.parentGlobe.config.flow.data.size[0];
    this.sizeφ = this.parentGlobe.config.flow.data.size[1];

    this.countfps = 0; //a counter to determine fps
    this.lastfpscount = Date.now();
    this.effectiveyrpersdiv = $("#" + this.parentGlobe.name + "parametersdiv").find(".animationspeedslider").parent("div").find(".effectiveyrpers");

  }

  initAll() {
    for (var i = 0; i<this.npart; i++) {
      this.particles[i].newposition = new Array(2);
      this.initPosition(i);
      this.particles[i].age = Math.random() * this.config.flow.maxage;
    }
  }

  initPosition(i) {
    ///var particle = this.particles[i];
    var θ = 0;
    var φ = 0;

    θ = (Math.asin((Math.random()-0.5) * 2) / Math.PI + 0.5) * 180;
    φ = Math.random() * 360; // [θ,φ] pos

    this.particles[i].position[0] = θ;
    this.particles[i].position[1] = φ;
    this.particles[i].newposition[0] = this.particles[i].position[0];
    this.particles[i].newposition[1] = this.particles[i].position[1];
    this.particles[i].age = 0;
  }

  setPosition(i,pos){
    this.particles[i].position[0] = pos[0];
    this.particles[i].position[1] = pos[1];
  }

  evolve() {
    for (var i = 0; i<this.npart; i++) {
      var particle = this.particles[i];
      if (particle.age > this.config.flow.maxage) {
        this.initPosition(i);
      }

      var θ = particle.position[0];
      var φ = particle.position[1];

      var v = this.parentGlobe.config.flow.data.interpolateVector(particle.position);  // vector at current position
      if (!v) {
        this.initPosition(i); // particle has escaped the grid, never to return...
      }
      else {
        var θnew = θ + v[0] * this.config.flow.timestep;
        var φnew = (φ + v[1] * this.config.flow.timestep + 360) % 360;//continuous particule in φ
        particle.newposition = [θnew,φnew];
        particle.speedNorm = v[2];
      }
      particle.age += 1;
    }
  }

  draw() {
    //counting fps
    this.countfps += 1;
    if (this.countfps == 10) {
      this.countfps = 0;
      var elapsedtime = (Date.now() - this.lastfpscount)/1e3;
      var measuredfps = 10/elapsedtime;

      if (measuredfps < this.parentGlobe.config.flow.fps * 0.95) {
        this.effectiveyrpersdiv.text( " (" + (measuredfps * this.parentGlobe.particles.config.flow.timestep).toFixed(1) + ") ");
      } else {
        this.effectiveyrpersdiv.empty();
      }
      this.lastfpscount = Date.now();
    }


    var thisglobe = this.parentGlobe;
    var context = thisglobe.particleContext;


    var projection = (thisglobe.config.flow.earthSurface ? thisglobe.earthSurfaceProjection : thisglobe.projection);

    var rotation = thisglobe.geoToSpher(projection.rotate());
    var allPointVisible = thisglobe.allPointVisible;
    var isPointVisible = thisglobe.customGlobe.isPointVisible;
    var spherToGeo = thisglobe.spherToGeo;
    var hasDiscontinuity = (thisglobe.customGlobe.isDiscountinuous == undefined ? false : true);
    var discontinuity = null;

    var prev = context.globalCompositeOperation;
    context.fillStyle = "rgba(0, 0, 0, "+ thisglobe.config.flow.particleTail +")";
    context.globalCompositeOperation = "destination-in";
    context.fillRect(0,0, thisglobe.width,thisglobe.height);
    context.globalCompositeOperation = prev;

    context.strokeStyle = "#ffffff";
    context.lineCap="round";
    //var sizeVariation = 2/thisglobe.config.flow.data.magmax;

    var nDrawPools = 1+Math.ceil(thisglobe.config.flow.maxParticleSize - thisglobe.config.flow.minParticleSize);
    if (nDrawPools>1) {
      this.particles.sort(function(a,b) {return (a.speedNorm - b.speedNorm);} );
    }
    var currentDrawPool = 0;

    var poolsEnds = linspace(thisglobe.flowColorScale.domain[0],thisglobe.flowColorScale.domain[thisglobe.flowColorScale.domain.length-1],nDrawPools+1).slice(1,nDrawPools);

    context.lineWidth=thisglobe.config.flow.minParticleSize;
    context.beginPath();
    for (var i = 0; i<this.npart; i++) {
      var particle = this.particles[i];

      if (nDrawPools>1 && particle.speedNorm > poolsEnds[currentDrawPool]) {
        context.stroke();
        currentDrawPool++;
        context.lineWidth=thisglobe.config.flow.minParticleSize +
                          (thisglobe.config.flow.maxParticleSize - thisglobe.config.flow.minParticleSize)*
                          currentDrawPool/(nDrawPools-1);
        context.beginPath();
      }

      //check if particle is not crossing discontinuity
      if (hasDiscontinuity) {
        if (thisglobe.customGlobe.isDiscountinuous.call(thisglobe,particle.position,particle.newposition)) {
          this.setPosition(i,particle.newposition);
          continue;
        }
      }

      var geoPos = spherToGeo(particle.position);
      var geoNewPos = spherToGeo(particle.newposition);
      //console.log(geoPos,geoNewPos)
      if (!allPointVisible) {
        if (!isPointVisible(particle.newposition,rotation)) {
          this.setPosition(i,particle.newposition);
          continue;
        }
      }
      if (!geoNewPos) { //out of bounds
        this.initPosition(i);
      }
      else {
        /*context.beginPath();
        context.lineWidth=thisglobe.config.flow.minParticleSize +
                          (thisglobe.config.flow.maxParticleSize - thisglobe.config.flow.minParticleSize)*
                          (particle.speedNorm-this.parentGlobe.config.flow.data.magmin)/
                          (this.parentGlobe.config.flow.data.magmax-this.parentGlobe.config.flow.data.magmin);
        */
        context.moveTo(...projection(geoPos));
        context.lineTo(...projection(geoNewPos));
        /*context.stroke();*/
      }
      this.setPosition(i,particle.newposition);

    }
    context.stroke();

    context.globalCompositeOperation = "source-in";
    context.drawImage(document.getElementById(this.parentGlobe.name+"colorflowcanvas"),0,0);
    context.globalCompositeOperation = prev;

  }



}



//////////////////
// WEBPACK FOOTER
// ./src/model/particles.js
// module id = 5
// module chunks = 0